import SendOutlined from '@ant-design/icons/SendOutlined'
import { Button, Form, Input, Space } from 'antd'
import { ChatInputProps } from 'features/drilldown/panels/global/llmPanel/types'
import React, { FC, useEffect, useRef } from 'react'
import styled from 'styled-components'

const { TextArea } = Input

// Minimal styling
const InputContainer = styled.div`
  padding: 16px;
`

export const ChatInput: FC<ChatInputProps> = ({
  value,
  onChange,
  onSend,
  isLoading,
  disabled = false,
}) => {
  const [form] = Form.useForm()
  const inputRef = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    if (!isLoading) {
      inputRef.current?.focus()
    }
  }, [isLoading])

  const handleSend = () => {
    if (!value.trim() || isLoading || disabled) return
    onSend()
    form.setFieldsValue({ query: '' })
  }

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey && !isLoading && value.trim()) {
      e.preventDefault()
      handleSend()
    }
  }

  return (
    <InputContainer>
      <Form form={form} onFinish={handleSend} style={{ width: '100%' }}>
        <Space.Compact style={{ width: '100%' }}>
          <Form.Item
            name='query'
            noStyle
            rules={[
              {
                required: true,
                message: 'Please enter your message',
              },
            ]}>
            <TextArea
              ref={inputRef}
              value={value}
              onChange={(e) => onChange(e.target.value)}
              onPressEnter={handleKeyPress}
              placeholder='Ask AI anything...'
              autoSize={{ minRows: 1, maxRows: 4 }}
              disabled={isLoading || disabled}
            />
          </Form.Item>
          <Button
            type='primary'
            htmlType='submit'
            icon={<SendOutlined />}
            disabled={!value.trim() || isLoading || disabled}
            loading={isLoading}>
            Send
          </Button>
        </Space.Compact>
      </Form>
    </InputContainer>
  )
}
